export const STATE_KEY = 'titleList';

export const TITLES_FETCH_KEY = 'title-list.fetch';
export const TITLES_LAZY_LOAD_FETCH_KEY = 'title-list-lazy-load.fetch';

export const PAGE_SIZE = 20;
